import { Component, Input } from '@angular/core';
import { getFieldValue, getTreeListValues } from '@core/jss-utils';
import { InnogyComponentRendering } from '@core/jss-models';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import { TrackImpressionDirective } from '@analytics/events';

import { HowToQuestionnaireQuestionComponent } from './how-to-questionnaire-question/how-to-questionnaire-question.component';

@Component({
  selector: 'wl-how-to-questionnaire-container',
  templateUrl: './how-to-questionnaire-container.component.html',
  standalone: true,
  imports: [HowToQuestionnaireQuestionComponent, TrackImpressionDirective],
})
export class HowToQuestionnaireContainerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;

  get backToPreviousButtonText(): string | undefined {
    return getFieldValue<string>(this.rendering, 'BackToPreviousButtonText');
  }

  get backToBeginningButtonText(): string | undefined {
    return getFieldValue<string>(this.rendering, 'BackToBeginningButtonText');
  }

  get firstQuestion(): InnogyComponentRendering | undefined {
    return this.rendering?.fields?.['FirstQuestion'] as
      | InnogyComponentRendering
      | undefined;
  }

  get questions(): InnogyComponentRendering[] {
    return getTreeListValues<InnogyComponentRendering>(
      this.rendering?.fields,
      'Questions'
    );
  }
}
